import {AuthResponse} from 'airship/clients/auth/types'
import {
  objectResolver,
  resolveBoolean,
  resolveString,
} from 'airship/utils/resolvers'
import {Resolver} from 'airship/utils/resolvers/types'

export type LoginPageContext = {
  displayAccountRegistration: boolean
  recaptchaSiteKey: string
  requireCaptcha: boolean
}

export const resolveLoginPageContext: Resolver<LoginPageContext> = objectResolver(
  {
    displayAccountRegistration: resolveBoolean,
    recaptchaSiteKey: resolveString,
    requireCaptcha: resolveBoolean,
  }
)

export type FindUserData = AuthResponse & {displayLogin?: boolean}
